import React from 'react'
import footerImg from '../../../assets/footer.png'
import { toPage } from '../../utils'
import './index.less';

function Footer() {
  return (
    <div className='footer-wrapper'>
      <div className="footer-content" style={{
        backgroundImage: `url(${footerImg})`
      }}>
        <div className="footer-content-title">立即申请入驻遥望云链</div>
        <div className="footer-content-btn" onClick={() => toPage('为了更好的入驻体验，请前往PC端完成入驻')}>
          商家入驻
        </div>
      </div>
    </div>
  )
}

export default Footer

